<template>
    <div class="relative px-[20px] lg:px-[40px]">
        <step-options-initials-buttons
            v-if="Array.isArray(visiblePlacementsStamps) && visiblePlacementsStamps.length > 0"
            :has-add-remove-button="hasAddRemoveButton"
            :has-local-error="hasLocalErrorState"
            :main-placement="visiblePlacementsStamps?.[0]"
            :option="stampOption"
            @unselect="handleSelectNothing"
            @select="handleSelectAndOpenStampsOptionsPanel"
            :index="0"
            :scroll-to-offset="scrollToOffset"
            :scroll-to-timeout="100"
            :has-error-state="hasLocalErrorState"
            :all-components="allComponents"
            :use-palette-color-selection="true"
            :has-image="true"
            :open-when-selected="true"
            :should-scroll-to-clicked-button="false"
            :remove-selected-on-add-remove-click="true"
            :should-show-edit-button="true"
            @open="handleOpenStampsOptionsPanel"
            background-size="auto 100%"
        />
    </div>
</template>

<script>
    import allStores from '../stores/all';
    import StepOptionsInitialsButtons from './buttons/StepOptionsInitialsButtons.vue';

    export default {
        mixins: [allStores],

        components: {
            StepOptionsInitialsButtons,
        },

        props: {
            visiblePlacementsStamps: {
                type: Array,
                required: true,
            },

            hasLocalErrorState: {
                type: Boolean,
                required: true,
            },

            hasAddRemoveButton: {
                type: Boolean,
                default: false,
            },

            stampsIsActive: {
                type: Boolean,
                required: true,
            },

            isDirty: {
                type: Boolean,
                default: false,
            },

            scrollToOffset: {
                type: Number,
                default: 24,
            },
        },

        computed: {
            isMobile() {
                return this.appStore?.isMobile;
            },

            viewController() {
                return this.customizerStore.viewController;
            },

            allComponents() {
                if (!Array.isArray(this.visiblePlacementsStamps)) { return []; }
                const fullMainPlacement = this.visiblePlacementsStamps.find((x) => x.code === 'Stamp');
                return fullMainPlacement?.components || [];
            },

            visiblePlacementsStampsColors() {
                if (!Array.isArray(this.visiblePlacementsStamps)) { return []; }
                return this.visiblePlacementsStamps.filter((x) => x.code.includes('Color'));
            },

            stampOption() {
                const stampPlacement = this.visiblePlacementsStamps.find((x) => x.code === 'Stamp');

                const component = stampPlacement?.components?.find((x) => !x.placeholder);

                if (!component) {
                    return null;
                }

                return {
                    selected: this.stampsIsActive,
                    label: 'Stamps',
                    value: 'Stamps',
                    raw: {
                        ...component,
                        custom: {
                            ...(component.custom || {}),
                            ...{
                                'v-thumbnail-asset': 'PutterFace-StampsSelected',
                            },
                        },
                    },
                };
            },
        },

        watch: {
            visiblePlacementsStampsColors: {
                immediate: true,
                deep: true,
                handler(nextPlacements) {
                    this.customizerStore.syncFrontStampsSubOptionsFromPlacements(nextPlacements);
                },
            },
        },

        mounted() {
            if (this.stampsIsActive) {
                this.customizerStore.setActiveView('Face');
            }
        },

        methods: {
            handleSelectNothing() {
                this.customizerStore.resetStamps();
                this.$emit('unselect');
            },

            handleSelectAndOpenStampsOptionsPanel({ placement, option }) {
                this.selectActual({ placement, option });
                this.handleOpenStampsOptionsPanel();
            },

            handleOpenStampsOptionsPanel() {
                this.appStore.openNestedPanel('frontStampsOptions', {
                    visiblePlacementsStamps: this.visiblePlacementsStamps,
                    isDirty: this.isDirty,
                });
            },

            selectActual({ placement, option }) {
                // Handle both cases: strings from button click, or objects from icon click
                const placementCode = typeof placement === 'string' ? placement : placement.code;
                let optionValue = typeof option === 'string' ? option : option.value;

                // If button was clicked with 'Stamps' value, find and select first non-blank stamp component
                if (optionValue === 'Stamps' && placementCode === 'Stamp') {
                    const stampPlacement = this.visiblePlacementsStamps.find((x) => x.code === 'Stamp');
                    if (stampPlacement) {
                        const firstNonBlank = stampPlacement.components.find(
                            (c) => !c.code.includes('Blank') && !c.placeholder && this.viewController.isAvailable(c),
                        );
                        if (firstNonBlank) {
                            optionValue = firstNonBlank.code;
                        }
                    }
                }

                this.customizerStore.setSelection(placementCode, optionValue);

                // Emit the option value for the parent component
                const optionToEmit = typeof option === 'string' ? { value: optionValue } : option;
                this.$emit('select', optionToEmit);

                this.customizerStore.setActiveView('Face');
            },
        },
    };
</script>
